import type { ColumnConfig } from '../../../hooks/useTableColumns';

export const financeDefaultColumns: ColumnConfig[] = [
  {
    key: 'index',
    title: 'ID',
    width: 80,
    minWidth: 60,
    maxWidth: 100,
    visible: true,
    fixed: 'left',
    order: 0,
    resizable: false,
    draggable: false,
  },
  {
    key: 'contact_name',
    title: '联系人',
    dataIndex: 'contact_name',
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 1,
    resizable: true,
    draggable: true,
  },
  {
    key: 'case_name',
    title: '案件名称',
    dataIndex: 'case_name',
    width: 150,
    minWidth: 120,
    maxWidth: 300,
    visible: true,
    fixed: false,
    order: 2,
    resizable: true,
    draggable: true,
  },
  {
    key: 'expense_type',
    title: '费用类型',
    dataIndex: 'expense_type',
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 3,
    resizable: true,
    draggable: true,
  },
  {
    key: 'amount',
    title: '动款金额',
    dataIndex: 'amount',
    width: 120,
    minWidth: 100,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 4,
    resizable: true,
    draggable: true,
  },
  {
    key: 'payment_time',
    title: '动款时间',
    dataIndex: 'payment_time',
    width: 160,
    minWidth: 140,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 5,
    resizable: true,
    draggable: true,
  },
  {
    key: 'payment_nature',
    title: '款项类型',
    dataIndex: 'payment_nature',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 6,
    resizable: true,
    draggable: true,
  },
  {
    key: 'invoices',
    title: '发票',
    dataIndex: 'invoices',
    width: 80,
    minWidth: 60,
    maxWidth: 120,
    visible: true,
    fixed: false,
    order: 7,
    resizable: true,
    draggable: true,
  },
  {
    key: 'attachments',
    title: '附件',
    dataIndex: 'attachments',
    width: 80,
    minWidth: 60,
    maxWidth: 120,
    visible: true,
    fixed: false,
    order: 8,
    resizable: true,
    draggable: true,
  },
  {
    key: 'responsible_person_name',
    title: '线索/案件负责人',
    dataIndex: 'responsible_person_name',
    width: 120,
    minWidth: 100,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 9,
    resizable: true,
    draggable: true,
  },
  {
    key: 'remark',
    title: '备注',
    dataIndex: 'remark',
    width: 200,
    minWidth: 150,
    maxWidth: 400,
    visible: true,
    fixed: false,
    order: 10,
    resizable: true,
    draggable: true,
  },
  {
    key: 'created_at',
    title: '创建时间',
    dataIndex: 'created_at',
    width: 160,
    minWidth: 140,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 11,
    resizable: true,
    draggable: true,
  },
  {
    key: 'action',
    title: '操作',
    width: 220,
    minWidth: 180,
    maxWidth: 300,
    visible: true,
    fixed: 'right',
    order: 12,
    resizable: false,
    draggable: false,
  },
];
